import clsx from "clsx";

type Props = React.SVGAttributes<SVGSVGElement> & { accentColor?: string; fillPercent: number };

export default function CircleIndicator({
  fillPercent,
  className,
  accentColor = "#FFFFFF",
  strokeWidth,
  ...restProps
}: Props) {
  const R = 11;
  const length = 2 * Math.PI * R;
  const dashoffset = length / 4;
  const onePercent = length / 100;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={clsx("rotate-y-180", className)}
      {...restProps}
    >
      <circle cx={12} cy={12} r={12} fill={accentColor} fillOpacity={0.14} />
      <circle
        cx={12}
        cy={12}
        r={11}
        strokeWidth={strokeWidth || 2}
        fill="none"
        stroke={accentColor}
        strokeOpacity={0.3}
      />
      <circle
        cx={12}
        cy={12}
        r={11}
        strokeWidth={strokeWidth || 2}
        fill="none"
        strokeLinecap="round"
        stroke={accentColor}
        strokeDashoffset={dashoffset}
        strokeDasharray={`${onePercent * fillPercent} ${length - onePercent * fillPercent}`}
      />
    </svg>
  );
}
